<template>
  <div>
    <p>Anmeldung in Progress..</p>
  </div>
</template>

<script>
export default {
  name: "SigningIn"
}
</script>

<style scoped>

</style>
